module.exports = __webpack_public_path__ + "static/media/Document.af99d207.svg";